import { Appear, Notes, Head, Image, FullScreenCode, Horizontal, Invert, Split, SplitRight } from '..';
export default {
  Appear: Appear,
  Notes: Notes,
  Head: Head,
  Image: Image,
  FullScreenCode: FullScreenCode,
  Horizontal: Horizontal,
  Invert: Invert,
  Split: Split,
  SplitRight: SplitRight
};